import React, { memo } from 'react'
import { string } from 'prop-types'
import { useTheme } from 'emotion-theming'

export const BlockBDCNavy = memo(({ height = '100%', width = '100%' }) => {
	const {
		colors: { primary, secondary, white },
	} = useTheme()

	return (
		<svg
			height={height}
			width={width}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 360 124.8"
			style={{ enableBackground: 'new 0 0 360 124.8' }}
			xmlSpace="preserve"
		>
			<g>
				<polygon
					fill={primary}
					points="95.6,0 15.9,0 0,0 0,100 15.9,100 15.9,124.8 44.9,100 73.5,100 360,100 360,0"
				/>
				<g>
					<path
						fill={white}
						d="M49.2,34.2v8.6c0,0.9,0,1.6-0.4,5.5h0.1c1.3-2.9,3.6-4.5,7.2-4.5c4.9,0,8.3,3.7,8.3,9.8
						c0,7.3-4,12.6-11.9,12.6c-3.1,0-7.2-0.8-8.9-1.8V38.4h-3.3v-4.2H49.2z M49.1,60.7c0.8,0.4,2.4,0.8,3.6,0.8c3.8,0,5.9-3,5.9-7.3
						c0-3.6-1.6-5.8-4.7-5.8c-3.1,0-4.9,2.1-4.9,5.3V60.7z"
					/>
					<path
						fill={white}
						d="M74.8,44.3v12.2c0,3.9,1.1,5,3.8,5c2.5,0,4.5-2,4.5-5.2v-7.8h-2.7v-4.2h8.4v17.2h2.5v4.2h-8
						c0-2.5,0.2-3.9,0.5-4.4h-0.1c-1.3,3.4-3.7,4.9-7.4,4.9c-5,0-7.2-3.2-7.2-7.3V48.4h-2.9v-4.2H74.8z"
					/>
					<path
						fill={white}
						d="M111.9,50.5h-5.1v-2.2c-1.1-0.4-2.2-0.6-3.3-0.6c-2.6,0-3.8,1.1-3.8,2.2c0,1.5,0.5,1.6,6.3,2.3
						c5.1,0.7,7.1,2.5,7.1,6.5c0,4.5-3.6,7.4-10.1,7.4c-2.4,0-6.4-0.6-8.4-1.3v-6h5.1v2.5c1,0.3,2.6,0.7,3.8,0.7
						c2.1,0,4.2-0.9,4.2-2.6c0-1.6-1.2-1.9-7.8-2.9c-4-0.6-5.6-2.6-5.6-5.7c0-4.4,3.7-7,9.4-7c2.3,0,5.1,0.3,8.3,1.4V50.5z"
					/>
					<path fill={white} d="M124.2,44.3v17.2h2.5v4.2h-10.5v-4.2h2.3v-13h-2.8v-4.2H124.2z" />
					<path
						fill={white}
						d="M152.2,61.5h2.5v4.2h-10.5v-4.2h2.3v-8.9c0-2.7-1.5-3.9-3.7-3.9c-3.2,0-5,2.2-5,5.5v7.3h2.5v4.2h-10.3v-4.2
						h2.1v-13h-2.8v-4.2h8.4c0,1.6,0,2.8-0.3,4.4h0.1c1.1-2.8,3.6-4.9,7.4-4.9c5.1,0,7.4,3.4,7.4,8.2V61.5z"
					/>
					<path
						fill={white}
						d="M162.6,56.3c0.2,3.4,2.7,5.5,6.8,5.5c2.6,0,4.4-0.4,6.9-1.5l-0.3,4.5c-2.7,1-4.9,1.3-7.8,1.3
						c-7.5,0-11.8-4.3-11.8-11.1c0-6.8,4.2-11.3,10.7-11.3c6.3,0,10.3,4.2,10.3,12.5H162.6z M171.3,52.3c0-2.9-1.6-4.6-4.4-4.6
						c-2.5,0-4,1.6-4.3,4.6H171.3z"
					/>
					<path
						fill={white}
						d="M197.9,50.5h-5.1v-2.2c-1.1-0.4-2.2-0.6-3.3-0.6c-2.6,0-3.8,1.1-3.8,2.2c0,1.5,0.5,1.6,6.3,2.3
						c5.1,0.7,7.1,2.5,7.1,6.5c0,4.5-3.6,7.4-10.1,7.4c-2.4,0-6.4-0.6-8.4-1.3v-6h5.1v2.5c1,0.3,2.6,0.7,3.8,0.7
						c2.1,0,4.2-0.9,4.2-2.6c0-1.6-1.2-1.9-7.8-2.9c-4-0.6-5.6-2.6-5.6-5.7c0-4.4,3.7-7,9.4-7c2.3,0,5.1,0.3,8.3,1.4V50.5z"
					/>
					<path
						fill={white}
						d="M219.5,50.5h-5.1v-2.2c-1.1-0.4-2.2-0.6-3.3-0.6c-2.6,0-3.8,1.1-3.8,2.2c0,1.5,0.5,1.6,6.3,2.3
						c5.1,0.7,7.1,2.5,7.1,6.5c0,4.5-3.6,7.4-10.1,7.4c-2.4,0-6.4-0.6-8.4-1.3v-6h5.1v2.5c1,0.3,2.6,0.7,3.8,0.7
						c2.1,0,4.2-0.9,4.2-2.6c0-1.6-1.2-1.9-7.8-2.9c-4-0.6-5.6-2.6-5.6-5.7c0-4.4,3.7-7,9.4-7c2.3,0,5.1,0.3,8.3,1.4V50.5z"
					/>
					<path
						fill={white}
						d="M253.5,51.1h-4.9v-2.9c-0.9-0.2-1.3-0.2-2-0.2c-3.4,0-5.4,2.9-5.4,6.4c0,4.3,2.5,7.1,6.8,7.1
						c1.8,0,3.6-0.4,5.4-1.2l-0.3,4.8c-2.3,0.8-3.2,1-6.3,1c-7,0-11.2-4.6-11.2-11.2c0-6.9,4.4-11.2,11.3-11.2c2.6,0,4.7,0.4,6.7,1
						V51.1z"
					/>
					<path
						fill={white}
						d="M267.2,66.1c-7.2,0-11.2-4-11.2-11c0-6.3,4.5-11.4,11.2-11.4c7.3,0,11.2,4,11.2,11.4
						C278.4,61.6,273.9,66.1,267.2,66.1z M272.2,55.3c0-4.6-1.5-6.9-5.1-6.9c-2.9,0-5,2.3-5,6.9c0,3.9,1.5,6.2,5,6.2
						C270.7,61.5,272.2,59.2,272.2,55.3z"
					/>
					<path
						fill={white}
						d="M302.8,48.6c1-3,3.4-4.8,7.2-4.8c5.1,0,7.4,3.4,7.4,8.2v9.5h2.5v4.2h-10.3v-4.2h2.1v-8.9
						c0-2.7-1.5-3.9-3.7-3.9c-2.8,0-4.5,2.4-4.5,5.5v7.3h2.5v4.2h-10.3v-4.2h2.1v-8.9c0-2.7-1.5-3.9-3.7-3.9c-2.9,0-4.5,2.4-4.5,5.5
						v7.3h2.5v4.2h-10.5v-4.2h2.3v-13h-2.8v-4.2h8.4c0,1.5,0,2.9-0.3,4.3h0.1c1.2-3.1,3.8-4.8,7.4-4.8C300,43.8,302.1,45.4,302.8,48.6
						L302.8,48.6z"
					/>
				</g>
				<circle fill={white} cx="121.1" cy="37.2" r="3.6" />
				<circle fill={secondary} cx="228.2" cy="62.7" r="3.7" />
			</g>
		</svg>
	)
})

BlockBDCNavy.propTypes = {
	height: string,
	width: string,
}
